export enum SoldStatusEnum {
  Active = 1,
  Sold = 2,
  Unsold = 3,
  Draft = 4,
  Provisional = 5,
  Withdrawn = 6,
}
